import { Controller } from "@hotwired/stimulus"

export default class CreateProjectController extends Controller {
  static values = {
    id: String,
    url: String
  }

  connect() {
    console.log("CreateProjectController connected")
    this.modal = document.getElementById("linkProjectModal")
  }

  openModal(event) {
    console.log("Opening modal for project ID:", this.idValue)
    // Set the project ID and URL on the modal
    this.modal.dataset.createProjectIdValue = this.idValue
    this.modal.dataset.createProjectUrlValue = this.urlValue
    this.modal.showModal()
  }
  
  closeModal(event) {
    this.modal.close()
  }

  linkToClient(event) {
    event.preventDefault()
    const selectedClientId = document.getElementById("existingClientSelect").value
    const projectId = this.modal.dataset.createProjectIdValue
    const url = this.modal.dataset.createProjectUrlValue

    console.log("Linking project ID:", projectId, "to client ID:", selectedClientId)
    console.log("URL:", url)

    if (selectedClientId && projectId && url) {
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          project_id: projectId,
          client_id: selectedClientId
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json()
      })
      .then(data => {
        if (data.success) {
          console.log("Project linked successfully:", data.message)
          location.reload()
        } else {
          console.error("Error linking project to client:", data.error || data.errors)
          // You might want to display this error to the user
        }
      })
      .catch(error => {
        console.error('Error:', error)
      })
    } else {
      console.error("Missing required data for linking project to client")
    }

    this.closeModal()
  }
}